module.exports = __webpack_public_path__ + "static/media/talk_to_us.6a68165e.svg";